<template>
    <el-dialog title="会员激活" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-activation">
        <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
        <img src="../assets/images/close.png" alt="关闭" @click="closeActivationHandler()">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="激活码：" :label-width="formLabelWidth" prop="password">
                <el-input v-model="ruleForm.password" autocomplete="off" placeholder="请输入会员激活码"></el-input>
            </el-form-item>
           <!--  <el-form-item label="高考年份：" :label-width="formLabelWidth" prop="exam_year" v-if="isShowYear == '2'">
                <el-select v-model="ruleForm.exam_year" placeholder="请选择您的高考年份">
                    <el-option
                    v-for="item in yearList"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <p v-if="isShowYear == '2'">高考年份在激活后不可修改，请确认无误后激活！</p> -->
        </el-form>
        <div class="dialog-footer">
            <el-button type="primary" @click="confirmActivationHandler()">确认激活</el-button>
        </div>
        <div class="skip-box" v-if="isNewUser == 'true'">
            <span @click="closeActivationHandler">跳过，以后再激活</span>
        </div>
        <div class="activation-text">
            <p class="activation-p">提示：</p>
            <p>如无会员激活码，请与{{ website.name ? website.name : '荔枝生涯' }}工作人员联系。</p>
        </div>
    </el-dialog>
</template>

<script>
import { activateCard,cardType } from '@/api/vip'
import { checkVip } from '@/api/vip'
import { mapState } from 'vuex'
export default {
    name: "Activation",
    data() {
        const validateCode = (rule, value, callback) => {
            if(value == '') {
                callback(new Error('请输入激活码'));
            } else {
                callback();
            }
        };
        return {
            formLabelWidth: '105px',
            ruleForm: {
                password: '',
                exam_year: ''
            },
            yearList: [],
            rules: {
                password: [
                    { required: true, trigger: 'blur', validator: validateCode }
                ],
                exam_year: [
                    { required: true }
                ],
            },
            isNewUser: localStorage.getItem("isNewUser"),
            isShowYear: '0'
        };
    },
    computed: { 
        ...mapState({
                website: state => state.user.website
            })
    },
    created () {
    },
    methods: {
        showSelectYearHandler() {
            let date = new Date();
            let yearList = [];
            for (let i = 0; i < 3; i++) {
                if(date.getMonth() > 7) {
                    yearList.push(date.getFullYear() + i + 1);
                } else {
                    yearList.push(date.getFullYear() + i);
                }
            }
            this.yearList = [...yearList];
            if(date.getMonth() > 7) {
                this.ruleForm.exam_year = date.getFullYear() + 1;
            } else {
                this.ruleForm.exam_year = date.getFullYear();
            }
        },
        closeActivationHandler() {
            this.$store.commit('user/SHOWADDVIP', false);
        },
        confirmActivationHandler() {
            this.$refs.ruleForm.validate((valid) => {
                // if (valid && this.isShowYear != '0') {
                let { password, exam_year } = this.ruleForm;
                activateCard(password, exam_year).then(res => {
                    if(res.status == 200) {
                        this.$store.commit('user/SHOWADDVIP', false);
                        this.$store.commit('user/VIPSTATUS', 'true');
                        this.$store.commit('user/ADDCOUNT', 0);
                        localStorage.setItem("isAddVip",'true');
                        this.$message({
                            message: '激活成功',
                            type: 'success'
                        });
                        this.checkVipHandler()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                }).catch(error => {
                    // this.$message({
                    //     message: '激活失败',
                    //     type: 'error'
                    // });
                    console.log(error)
                });
                // }
            })
        },
        checkVipHandler() {
            checkVip().then(res => {
                const function_code = res.data.function_code;
                this.$store.commit('user/VIPTYPESTATUS',res.data.has_code);
                this.$store.commit('user/FUNCTIONCODE',function_code);
            })
        },
        cardTypeHandler() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    cardType(this.ruleForm.password).then(res => {
                        if(res.status != 200) {
                            this.$message({
                                type: 'warning',
                                message: res.message
                            })
                            this.isShowYear = '0'
                            return
                        }
                        if(res.data.is_choose_year == '0') {
                            this.isShowYear = '1'
                            this.ruleForm.exam_year = ''
                        } else {
                            this.isShowYear = '2'
                            this.showSelectYearHandler();
                        }
                    })
                }
            })
        }
    }
}
</script>

<style lang='scss' scoped>
@import "@/assets/css/variables.scss";
.dialog-box {
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
    }
    .dialog-footer {
        padding: 0;
        button {
            width: 496px;
            height: 52px;
            background: linear-gradient(133deg,#ffce5d 1%, #ffa02f 97%, #ffa02f 97%)!important;
            border-radius: 8px;
            margin: 0 auto;
            font-size: 18px!important;
            color: #ffffff!important;
            position: relative;
            left: 50%;
            border: none;
            transform: translateX(-50%);
            margin-top: 15px;
        }
    }
    .activation-text {
        margin-top: 32px;
        color: #5e6166;
        font-size: 16px;
        p {
            margin: 8px 0;
        }
        .activation-p {
            font-weight: 600;
            color: #5e6166;
            margin-bottom: 10px;
        }
    }
    .skip-box {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        color: $common-color;
        text-align: center;
        margin-top: 24px;
        cursor: pointer;
    }
}
</style>